import { useRef, useState } from "react";
import cx from "classnames";
// import useClickAway from "../../common/useClickAway.js";
import "./dropdown.scss";

import { node } from "prop-types";

const propTypes = {
  button: node.isRequired,
  children: node.isRequired,
};

const Dropdown = (props) => {
  const { button, children } = props;

  const [isOpen, setOpen] = useState(false);

  const dropdownRef = useRef();

  // useClickAway({ isOpen, setOpen, ref: dropdownRef });

  // const focusTrapRef = useFocusTrap({
  //   active: isOpen,
  // });

  // useEffect(() => {
  //   if (isOpen) {
  //     dropdownRef.current.querySelector("#dropdown").focus();
  //   }
  // }, [isOpen]);

  return (
    <div
      className={cx("dropdown", {
        "is-open": isOpen,
      })}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="dropdown__button"
        onClick={() => setOpen((o) => !o)}
        aria-labelledby="dropdown-button-label"
        aria-controls="dropdown"
        id="dropdown-button"
      >
        <span id="dropdown-button-label">{button}</span>

        <div className="dropdown__arrow">
          <svg
            viewBox="0 0 14 7"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="7"
            aria-hidden="true"
            role="img"
            focusable="false"
          >
            <path
              d="M13.667 6.667H.333L7.001 0z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </button>
      <div
        className="dropdown__dropdown"
        id="dropdown"
        role="dialog"
        tabIndex="-1"
        aria-hidden={!isOpen}
      >
        {children}
      </div>
    </div>
  );
};

Dropdown.propTypes = propTypes;
export default Dropdown;
